/**
 * @file        LeadAttributionCapture.tsx
 * @description Invisible client island in the root layout: records the
 *              landing's UTM tags / external referrer once per full page
 *              load, so LeadForm can attach them to the lead later.
 * @rule        Renders nothing. All logic lives in src/lib/leadAttribution.
 */
"use client";

import { useEffect } from "react";
import { captureLandingAttribution } from "@/lib/leadAttribution";

export default function LeadAttributionCapture() {
  useEffect(() => {
    captureLandingAttribution();
  }, []);
  return null;
}
